import { type LoyaltyUser } from '@koala/sdk';
import { useDispatch } from 'react-redux';
import { ConnectedChevronIcon, ConnectedPersonIcon } from '../uielements';
import {
  StyledFirstName,
  StyledHeaderAccountButton,
  StyledNotificationsCounter,
  StyledRewardsNotifications,
  StyledRewardNumber,
  StyledAwardIcon,
} from './styles';
import { CSS_CLASSES } from '@/constants/cssClassNames';
import meActions from '@/redux/me/actions';
import {
  getActiveRewardsAndOffersLength,
  getUnreadPersonalMessagesLength,
  supportsLoyalty,
} from '@/utils/loyalty';
import { Render } from '@/components/uielements/render';
import { useSelector } from '@/redux';

interface Props {
  me: LoyaltyUser | null;
}

const LoyaltyNavLink = ({ me }: Props) => {
  const dispatch = useDispatch();
  const {
    myOffers,
    redeemables: myRedeemables,
    messages: myMessages,
    loyaltyState,
  } = useSelector((state) => state.app.me);
  const organization = useSelector((state) => state.app.organization);
  // Count unread personal messages + offers + rewards
  const currentPoints = loyaltyState?.points ?? 0;
  const combinedRewardsLength =
    getActiveRewardsAndOffersLength(myRedeemables, myOffers, currentPoints) || 0;
  const totalNotifications = getUnreadPersonalMessagesLength(myMessages) + combinedRewardsLength;

  return (
    <StyledHeaderAccountButton
      aria-label="My account"
      onClick={() => dispatch(meActions.toggleAccountDropdown(true))}
    >
      <Render condition={supportsLoyalty(organization)}>
        <StyledNotificationsCounter
          data-css-override="StyledNotificationsCounter"
          className={CSS_CLASSES.GLOBAL_HEADER.AUTH_NOTIFICATION_COUNTER}
        >
          <ConnectedPersonIcon />

          {/* Notification counter - rewards and unread messages */}
          <StyledRewardsNotifications>
            <StyledAwardIcon />
            <StyledRewardNumber>{totalNotifications}</StyledRewardNumber> Rewards
          </StyledRewardsNotifications>
        </StyledNotificationsCounter>
      </Render>
      <StyledFirstName className={CSS_CLASSES.GLOBAL_HEADER.AUTH_USERNAME}>
        Hi, {me?.first_name}
      </StyledFirstName>
      <ConnectedChevronIcon />
    </StyledHeaderAccountButton>
  );
};

export default LoyaltyNavLink;
